import { render } from "./MainMenu.vue?vue&type=template&id=44c23a6d&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=44c23a6d&scoped=true&lang=css"

import exportComponent from "/Users/christopher/www/in-the-loop-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c23a6d"]])

export default __exports__